// A work order billed in parts (Pat, Oct 9 2026 — WO26117: two trips with a bill in between).
// After a bill goes out, offer to close the T&M work it covered as a part — A, B, or a name of
// the office's own — so the next bill only has what's done after it.
import { apiFetch } from '../services/apiClient';

// "A" → "Part A"; a name of its own ("Phase 1") reads as typed.
export const partLabel = name => (/^[A-Za-z0-9]{1,2}$/.test(String(name || '').trim()) ? `Part ${String(name).trim()}` : String(name || '').trim());

const md = d => (d ? new Date(String(d).slice(0, 10) + 'T12:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '');

// invoiceId, or { projectId, invoiceNo } for a work order's bill sent from the billing board.
export async function offerClosePart(invoiceId, { projectId = null, invoiceNo = null } = {}) {
  try {
    const q = invoiceId ? `/invoices/${invoiceId}/bill-part-suggestion`
      : `/invoices/lookup/bill-part-suggestion?project_id=${encodeURIComponent(projectId || '')}&invoice_no=${encodeURIComponent(invoiceNo || '')}`;
    const s = await apiFetch(q);
    if (!s || !s.ask) return false;
    const name = window.prompt(
      `Bill sent.\n\nClose the work on this bill as a part, so the next bill only has what’s done after it?\n\n`
      + `${s.days} day${s.days === 1 ? '' : 's'} through ${md(s.through)} will be locked on the T&M card (still there to read).\n\n`
      + 'Name this part — A, B, Phase 1… (Cancel leaves it open):', s.name || 'A');
    if (name == null) return false;
    await apiFetch(`/projects/${s.project_id}/bill-parts/close`, { method: 'POST', body: JSON.stringify({ name: name.trim() || s.name, through: s.through, invoice_id: s.invoice_id }) });
    window.dispatchEvent(new CustomEvent('titan:bill-parts-changed', { detail: { projectId: s.project_id } }));
    return true;
  } catch (e) {
    if (e && e.error) window.alert(e.error);
    return false;
  }
}
